<template style="">
  <div class="Rotation_chart_management">
    <!-- <el-button type="primary" style="margin-left:20px;margin-top:20px;" @click="go()">轮播图发布</el-button> -->
    <el-button type="primary" style="margin-left:20px;margin-top:20px;" @click="go2()">app轮播图发布</el-button>
    <div style="margin-left:20px;margin-top:20px;">
      <el-select v-model="RotaChartModule" placeholder="活动区域">
        <el-option v-for="(item, i) in value7" :key="i" :label="item.cDicEnglishValue" :value="item.dicKey"></el-option>
      </el-select>
      <el-button type="primary" style="margin-left:20px;" @click="ser()">查询</el-button>
      <el-button type="primary" style="margin-left:20px;" @click="resetfun()">重置</el-button>
    </div>
    <el-table :data="tableData" style="width: 98%;margin-left:1%;margin-top:20px;">
      <el-table-column prop="LineNumber" label="轮播顺序" width="180"></el-table-column>
      <el-table-column prop="MaterialName" label="标题" width="180"></el-table-column>
      <el-table-column prop="JumpContentLink" label="跳转内容链接"></el-table-column>
      <el-table-column prop="CreatedDate" label="发布时间"></el-table-column>
      <el-table-column prop="IsActive" label="是否启用">
        
        <template slot-scope="scope">
          <span>{{scope.row.IsActive==1?'是':'否'}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <span style="margin-left:10px;cursor:pointer;color:rgb(31, 52, 245);" @click="xg(scope.row)">修改</span>
          <span style="margin-left:10px;cursor:pointer;color:rgb(31, 52, 245);" @click="looks(scope.row,5)">查看</span>
          <span style="margin-left:10px;cursor:pointer;color:rgb(31, 52, 245);" @click="delfun(scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top:20px;">
      <el-pagination @current-change="handleCurrentChange" :current-page="PageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      value7: [],
      RotaChartModule: '',
      PageIndex: 1,
      PageSize: 10,
      Counts: 1,
    }
  },
  mounted() {
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 45 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.value7 = res.Data;
      }
    })
    this.loading();
  },
  methods: {
    resetfun(){
      this.RotaChartModule = '';
      this.PageIndex = 1;
      this.loading();
    },
    looks(row,val) {
      this.$router.push({
        path:'/propagate/Propagate_look',
        query:{ materialKey: row.MaterialKey,Type:5},
      })
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.loading();
    },
    loading() {
      this.$Http_Post('management/rotationChartManagement', { RotaChartModule: this.RotaChartModule, PageIndex: this.PageIndex, PageSize: this.PageSize, }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Counts = res.Counts
          this.tableData = res.Data
        }
      })
    },
    delfun(rom) {
      this.$Http_Post('management/materialDel', { MaterialKey: rom.MaterialKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message)
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    go() {
      this.$router.push({path:"/propagate/Carousel_map_release",query:{type:1}})
    },
    go2() {
      this.$router.push({path:"/propagate/app_management"})
    },
    ser() {
      this.loading();
    },
    xg(rom) {
      this.$router.push({path:"/propagate/Carousel_map_release",query:{type:2,MaterialKey:rom.MaterialKey}})
    }
  },
}
</script>
<style>
  .Rotation_chart_management{width: 100%;height: 100%;background-color: #fff;}
  .el-table--enable-row-transition .el-table__body td{text-align:center;}
</style>
